import { render, staticRenderFns } from "./SalesInvoiceExtracts.vue?vue&type=template&id=4ce9b48e&scoped=true"
import script from "./SalesInvoiceExtracts.vue?vue&type=script&lang=js"
export * from "./SalesInvoiceExtracts.vue?vue&type=script&lang=js"
import style0 from "./SalesInvoiceExtracts.vue?vue&type=style&index=0&id=4ce9b48e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce9b48e",
  null
  
)

export default component.exports